export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10908.8bef4afc.jpg";